// extracted by mini-css-extract-plugin
export default {"base":"PointList_base__yEiIH","point":"PointList_point__MjzVA"};